import React from "react";
import Image from '@/compat/Image';
import { Skeleton } from "@/components/ui/skeleton";

export default function SidebarShimmer({ toggled }: { toggled: boolean }) {
  return (
    <div
      className={`h-full transition-all duration-300 ease-in-out px-4 py-4 flex flex-col z-10
      ${toggled ? "w-[80px] items-center" : "w-[280px]"}`}
      style={{
        background: "linear-gradient(180deg, #1E40AF 0%, #1E3A8A 100%)",
        boxShadow: "4px 0px 20px 0px #1E40AF26",
      }}
    >
      {/* Header / Logo */}
      <div className="relative flex items-center justify-center px-3 pt-6 pb-7">
        {!toggled ? (
          <Image
            src="/logo_new.svg"
            alt="TheragenX Logo"
            width={169}
            height={41}
            className="w-[169px] h-[41px] justify-center"
            priority
          />
        ) : (
          <Image
            src="/closedsidebar.svg"
            alt="TheragenX Logo"
            width={41}
            height={41}
            className="w-[41px] h-[41px]"
            priority
          />
        )}
      </div>

      {/* Menu Items Shimmer */}
      <div className={`flex-1 flex flex-col mt-3 ${toggled ? "gap-1" : "gap-4 space-y-2"}`}>
        {[...Array(5)].map((_, sectionIdx) => (
          <div key={sectionIdx} className={`flex flex-col ${toggled ? "gap-0.5" : "gap-2"}`}>
            {/* Section Header */}
            {!toggled && (
              <div className="w-[240px] pl-3 h-[32px] flex items-center">
                <Skeleton className="h-4 w-24 bg-white/10 rounded" />
              </div>
            )}

            {/* Items */}
            <div className={`flex flex-col ${toggled ? "items-center gap-2" : "gap-2 ml-2"}`}>
              {[...Array(2)].map((_, itemIdx) => (
                <div key={itemIdx} className={`rounded-lg h-[36px] flex items-center ${toggled ? "justify-center w-[64px]" : "w-[220px] pl-3"}`}>
                  <Skeleton className={`bg-white/10 rounded ${toggled ? "w-8 h-8" : "w-6 h-6"}`} />
                  {!toggled && (
                    <Skeleton className="h-4 w-32 bg-white/10 rounded ml-3" />
                  )}
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
